import Instafeed from "instafeed.js";;
import './plugins/bigvideo';
import './plugins/cc-plugins';
//import './plugins/countup';
import './plugins/dropkick';
import './plugins/flexslider';
import './plugins/hammertime';
import './plugins/instafeed';
import './plugins/mailchimp-ajax';
import './plugins/navigation';    
import './plugins/slick';
import CountUp from './plugins/countup';

 
  

//
// namespace - COPPERCANE
//  
 
(function(COPPERCANE, $, undefined){

    
    var isMobile    = $(window).width() < 1025 || navigator.userAgent.match(/iPad/i) != null,
        ajaxEnabled = cc_ajax && cc_ajax.ajaxurl,

        // svg
        svg_close = window.SVG_CLOSE || '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="274 364 64 64" enable-background="new 274 364 64 64" xml:space="preserve"><g><circle fill="none" stroke="#B2BFC1" stroke-width="2" stroke-miterlimit="10" cx="306" cy="396" r="30.5"/><g><line fill="none" stroke="#3E444A" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" x1="317.5" y1="407.5" x2="294.5" y2="384.5"/><line fill="none" stroke="#3E444A" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" x1="317.5" y1="384.5" x2="294.5" y2="407.5"/></g></g></svg>',
        svg_back  = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 800 64 64" enable-background="new 0 800 64 64" xml:space="preserve"><g><circle fill="transparent" stroke="#acbabc" stroke-width="2" stroke-miterlimit="10" cx="32" cy="832" r="31"/><polyline fill="transparent" stroke="#3d4349" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" points="37.2,847.7 21.5,832 37.2,816.3"/></g></svg>';

    /* --------------------------------------------
     * --util
     * -------------------------------------------- */
    
   
    /** 
     * ajaxError
     *
     * jquery error handler. Report errors to the console
     */
    function ajaxError(jqxhr, textStatus, error){
        console.log("error");
        console.log(jqxhr);
        console.log(textStatus);
        console.log(error);
    }



    /**
     * tallestEl
     *
     * get the tallest element
     * @param $content // the content to loop through to find the tallest element
     * @return the height of the tallest element
     */
    function tallestEl($content){

        var h = 0;
        $content.each(function(){
            var $el     = $(this),
                _height = $el.css({
                'position' : 'static'
            }).height();

            if(_height > h)
                h = _height;

            $el.removeAttr('style');
        });

        return h;
    }

    /**
     * alignHeights
     *
     * align the heights of things
     * @param $el // the elements to align the heights of
     */
    function alignHeights($el){
        var tallest = tallestEl($el);
        $el.height(tallest);
    }

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    // http://davidwalsh.name/javascript-debounce-function
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };



    /**
     * Sets up the drawer dimensions
     */
    function setDrawerDimensions(){
        var headerHeight = $('#coppercane-header').outerHeight();

        $('.cc-brand-dropdown, .cc-main-nav nav').css('top', headerHeight + 'px');
    }


    var loader = (function(){

        var loadingInterval,
            loadSpeed = 200;


        /**
         * createLoaderMarkup
         *
         * creates and returns the loader markup
         * @return (string) // the loader markup
         */
        function createLoaderMarkup(){

            var markup = '<div class="cc-loader">';

            if( COPPERCANE.loader === undefined ){
                var svgHeader = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 29.3 60" enable-background="new 0 0 29.3 60" xml:space="preserve"><g><path fill="#3E444A" d="M29.3,19.9c-0.2,1.1-0.4,2.2-0.6,3.2c-0.7,3-2.2,5.6-4.7,7.5c-1.1,0.9-2.1,1.8-3.2,2.7c-2.8,2.4-4,5.5-3.9,9.2c0.1,4.1,0,8.2,0.1,12.3c0,0.4,0.3,0.9,0.7,1.2c1.3,1,2.8,1.5,4.4,1.7c1.7,0.3,3.5,0.4,5.3,0.5c0.2,0,0.5,0,0.9,0c0,0.6,0,1.1,0,1.7c-8.9,0-17.8,0-26.7,0c0-0.5,0-1,0-1.7c0.7,0,1.4,0,2.1,0c2.1-0.1,4.2-0.4,6.2-1.1c0.4-0.1,0.8-0.3,1.1-0.5c1.2-0.5,1.7-1.3,1.7-2.7c-0.1-4,0.1-8,0.1-12c0-3.2-1-6-3.5-8.2c-1.1-1-2.2-2.1-3.5-3c-3.5-2.7-5-6.3-5.5-10.6C-0.5,13.4,1,6.9,3.2,0.6C3.3,0.1,3.6,0,4,0c7,0,14.1,0,21.1,0c0.6,0,0.7,0.3,0.9,0.7c1.6,4.3,2.7,8.8,3.1,13.4c0,0.2,0.1,0.3,0.1,0.5C29.3,16.4,29.3,18.1,29.3,19.9z M17.9,58.3c-0.6-0.4-1.2-0.7-1.5-1.1c-0.4-0.5-1-1.1-1-1.7c-0.1-4.2-0.2-8.4-0.2-12.7c0-3.7,0.8-7.1,3.6-9.7c0.9-0.9,1.8-1.7,2.7-2.5c1.2-1.1,2.6-2.1,3.6-3.3c2.4-3,2.8-6.6,2.7-10.3c-0.1-5-1.2-9.9-2.8-14.6c-0.2-0.6-0.4-0.7-1-0.7c-5.8,0-11.6,0-17.3,0c-2.1,0-2.1,0-2.7,2c-1.6,5.6-2.8,11.2-2,17.1c0.5,3.5,1.8,6.5,4.7,8.7c1.4,1,2.6,2.2,3.8,3.4c1.6,1.6,2.9,3.4,3.3,5.6c0.3,1.5,0.5,3,0.5,4.5c0,4.1-0.1,8.3-0.1,12.4c0,0.4-0.2,0.8-0.4,1.1c-0.6,0.7-1.3,1.2-2,1.8C13.7,58.3,15.7,58.3,17.9,58.3z"/>',
                    loader_1  = svgHeader + '<path fill="#3E444A" d="M4.9,24.8c0,0,0.1,0.4,0.2,0.5c0.9,1.4,2.1,2.4,3.4,3.4c0.9,0.7,1.9,1.5,2.9,2.2c1.6,1.3,2.7,2.7,3.6,4.8c0.9-2.1,1.9-3.5,3.4-4.8c0.9-0.7,1.8-1.5,2.7-2.2c1.2-1,2.5-2,3.4-3.4c0.1-0.1,0.2-0.5,0.2-0.5H4.9z"/></g></svg>',
                    loader_2  = svgHeader + '<path fill="#3E444A" d="M26.1,14.8H3.4c0,0,0-0.1,0-0.1c-0.1,1.2-0.2,2.2-0.2,3.4c0.1,2.6,0.5,5.1,1.9,7.4c0.9,1.4,2.1,2.3,3.4,3.3c0.9,0.7,1.9,1.4,2.9,2.2c1.6,1.3,2.7,2.7,3.6,4.8c0.9-2.1,1.9-3.5,3.4-4.8c0.9-0.7,1.8-1.5,2.7-2.2c1.2-1,2.5-1.9,3.4-3.3c1.4-2.3,1.8-4.9,1.9-7.5C26.3,16.8,26.2,15.8,26.1,14.8C26.1,14.6,26.1,14.8,26.1,14.8z"/></g></svg>',
                    loader_3  = svgHeader + '<path fill="#3E444A" d="M26.1,14.5c-0.2-3.5-1.5-9.8-2.4-10.8c-3.8,0-6.2,0-8.9,0s-5.3,0-9.1,0c-0.8,1-2.2,7.3-2.4,10.8c-0.1,1.2-0.2,2.3-0.2,3.4c0.1,2.6,0.5,5.2,1.9,7.5c0.9,1.4,2.1,2.3,3.4,3.3c0.9,0.7,1.9,1.5,2.9,2.2c1.6,1.3,2.7,2.7,3.6,4.8c0.9-2.1,1.9-3.5,3.4-4.8c0.9-0.7,1.8-1.5,2.7-2.2c1.2-1,2.5-1.9,3.4-3.3c1.4-2.3,1.8-4.8,1.9-7.4C26.3,16.8,26.2,15.7,26.1,14.5z"/></g></svg>',
                    loaderArray = [loader_1, loader_2, loader_3];

                for(var i = 0; i < loaderArray.length; i++){
                    var _class = i == 0 ? ' active' : '';
                    markup += '<div class="loader-container' + _class + '">' + loaderArray[i] + '</div>';
                }
            } else {
                markup += '<div class="loader-container active loader--spin">' + COPPERCANE.loader + '</div>';
            }

            markup += '</div>';

            return markup;
        }

        /**
         * init
         *
         * the loading animation
         * @param $el // the element on which to add the loader
         */
        function init($el){

            var markup = createLoaderMarkup();

            $el.append(markup);

            if( COPPERCANE.loader === undefined ){
                loadingInterval = setInterval(function(){
                    var $active = $('.loader-container.active').removeClass('active'),
                        $next   = $active.next().length > 0 ? $active.next() : $('.loader-container:first-child');

                    $next.addClass('active');
                }, loadSpeed);
            }
        }



        /**
         * destroy
         *
         * destroy the loader and clear the interval
         * @param $el // where the loader is
         */
        function destroy($el){
            $('.cc-loader', $el).remove();
            clearInterval(loadingInterval);
        }


        return{
            init    : init,
            destroy : destroy
        };

    })(); // loader


    /* --------------------------------------------
     * --larger ux components
     * -------------------------------------------- */

     /* slick slider wine product */
     var wineSlider = $('.cc-wine-slider .slides-container');
     wineSlider.slick({
        dots: true,
        infinite: false,
        autoplay: false, 
        autoplaySpeed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'linear',
        appendDots: '.slick-slide[data-slick-index="0"] .product--text .overview-text',
        customPaging : function(slider, i) {
            var title = $(slider.$slides[i]).find('header .type-brown').text(),
                vintage = $(slider.$slides[i]).find('header .product-vintage').text();
            return '<a id="slick-slide-control0'+ i +'" class="slider-tab">' + title+'</a>';
        },
        prevArrow: '<div class="slick-prev"><?xml version="1.0" encoding="UTF-8"?><svg enable-background="new 0 0 57.8 57.2" version="1.1" viewBox="0 0 57.8 57.2" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><circle cx="29.2" cy="28.7" r="27.3" fill="#E2E2E2"/><g fill="none" stroke="#3D3D3D" stroke-miterlimit="10"><line x1="39.4" x2="19" y1="28.7" y2="28.7"/><polyline points="22.6 32.2 19 28.7 22.6 25.2"/></g></svg></div>',
        nextArrow: '<div class="slick-next"><?xml version="1.0" encoding="UTF-8"?><svg enable-background="new 0 0 57.8 57.2" version="1.1" viewBox="0 0 57.8 57.2" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><circle cx="29.2" cy="28.7" r="27.3" fill="#E2E2E2"/><g fill="none" stroke="#3D3D3D" stroke-miterlimit="10"><line x1="19" x2="39.4" y1="28.7" y2="28.7"/><polyline points="35.8 25.2 39.4 28.7 35.8 32.2"/></g></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              adaptiveHeight: true
            }
          }
        ]

      });
     /* slick slider wine product */
     var wineSliderQuilt = $('.cc-wine-slider .quilt-slides-container');
     wineSliderQuilt.slick({
        dots: true,
        infinite: false,
        autoplay: false,
        draggable: false,
        touchMove: false,
        autoplaySpeed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        slidesToShow: 1,  
        slidesToScroll: 1,
        cssEase: 'linear',
        appendDots: '.slick-slide[data-slick-index="0"] .product--text .overview-text',
        customPaging : function(slider, i) {
            var title = $(slider.$slides[i]).find('header .type-brown').text(),
                vintage = $(slider.$slides[i]).find('header .product-vintage').text();
            return '<a id="slick-slide-control0'+ i +'" class="slider-tab">'+title+'</a>';
        },
        prevArrow: '<div class="slick-prev"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 45.8 45.8" enable-background="new 0 0 45.8 45.8" xml:space="preserve"><g><g><g><circle fill="#333232" cx="22.8" cy="23" r="20"/></g></g><polyline fill="none" stroke="#FFFFFF" stroke-miterlimit="10" points="25.9,15 17.9,23 25.9,31   "/></g></svg></div>',
        nextArrow: '<div class="slick-next"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 45.8 45.8" enable-background="new 0 0 45.8 45.8" xml:space="preserve"><g><g><g><circle fill="#333232" cx="22.8" cy="23" r="20"/></g></g><polyline fill="none" stroke="#FFFFFF" stroke-miterlimit="10" points="19.7,31 27.7,23 19.7,15   "/></g></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              adaptiveHeight: true
            }
          }
        ]

      });

     $('.slick-prev').hide();

      wineSlider.on('afterChange', function(event, slick, currentSlide) {
        //If we're on the first slide hide the Previous button and show the Next
        if (currentSlide === 0) {
          $('.slick-prev').hide();
          $('.slick-next').show();
        }
        else {
            $('.slick-prev').show();
            $('.slick-next').show();
        }

        //If we're on the last slide hide the Next button.
        if (slick.slideCount === currentSlide + 1) {
            $('.slick-next').hide();
        }
      });
    wineSliderQuilt.on('afterChange', function (event, slick, currentSlide) {
        //If we're on the first slide hide the Previous button and show the Next
        if (currentSlide === 0) {
            $('.slick-prev').hide();
            $('.slick-next').show();
        }
        else {
            $('.slick-prev').show();
            $('.slick-next').show();
        }

        //If we're on the last slide hide the Next button.
        if (slick.slideCount === currentSlide + 1) {
            $('.slick-next').hide();
        }
    });
    /**
     * sliders
     *
     * all the sliders for the coppercane site
     */  
    var sliders = (function(){

        var $blockSliderEl  = $('.cc-slider'),
            $bannerSliderEl = $('.banner-slideshow--container'),
            $wineProdSlider = $('.cc-wine-slider'),
            prevIcon        = window.prevIcon !== undefined ? window.prevIcon : '<svg title="left carousel navigation arrow" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 42.7 85" enable-background="new 0 0 42.7 85" xml:space="preserve"><g><g><path fill="#3E444A" d="M0,0c0.1,0,0.1,0,0.2,0c23.5,0,42.5,19,42.5,42.5C42.7,66,23.6,85,0.2,85c-0.1,0-0.1,0-0.2,0L0,0z"/></g><polyline fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" points="19.7,33.6 10.7,42.5 19.7,51.4"/></g></svg>',
            nextIcon        = window.nextIcon !== undefined ? window.nextIcon : '<svg title="right carousel navigation arrow" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 42.7 85" enable-background="new 0 0 42.7 85" xml:space="preserve"><g><g><path fill="#3E444A" d="M42.7,0c-0.1,0-0.1,0-0.2,0C19,0,0,19,0,42.5C0,66,19,85,42.5,85c0.1,0,0.1,0,0.2,0V0z"/></g><polyline fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" points="23,33.6 31.9,42.5 23,51.4"/></g></svg>',
            elouanPrev      = '<?xml version="1.0" encoding="UTF-8"?><svg title="left carousel navigation arrow" enable-background="new 0 0 57.8 57.2" version="1.1" viewBox="0 0 57.8 57.2" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><circle cx="29.2" cy="28.7" r="27.3" fill="#E2E2E2"/><g fill="none" stroke="#3D3D3D" stroke-miterlimit="10"><line x1="39.4" x2="19" y1="28.7" y2="28.7"/><polyline points="22.6 32.2 19 28.7 22.6 25.2"/></g></svg>',
            elouanNext      = '<?xml version="1.0" encoding="UTF-8"?><svg title="right carousel navigation arrow" enable-background="new 0 0 57.8 57.2" version="1.1" viewBox="0 0 57.8 57.2" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><circle cx="29.2" cy="28.7" r="27.3" fill="#E2E2E2"/><g fill="none" stroke="#3D3D3D" stroke-miterlimit="10"><line x1="19" x2="39.4" y1="28.7" y2="28.7"/><polyline points="35.8 25.2 39.4 28.7 35.8 32.2"/></g></svg>',
            quiltPrev       = '<svg title="left carousel navigation arrow" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 45.8 45.8" enable-background="new 0 0 45.8 45.8" xml:space="preserve"><g><g><g><circle fill="#333232" cx="22.8" cy="23" r="20"/></g></g><polyline fill="none" stroke="#FFFFFF" stroke-miterlimit="10" points="25.9,15 17.9,23 25.9,31   "/></g></svg>',
            quiltNext       = '<svg title="right carousel navigation arrow" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 45.8 45.8" enable-background="new 0 0 45.8 45.8" xml:space="preserve"><g><g><g><circle fill="#333232" cx="22.8" cy="23" r="20"/></g></g><polyline fill="none" stroke="#FFFFFF" stroke-miterlimit="10" points="19.7,31 27.7,23 19.7,15   "/></g></svg>';
        /**
         * blockSliders
         *
         * align the heights of all the block sliders, and then make a flexslider out of it
         */
        function blockSliders(){
            $blockSliderEl.each(function(){
                var maxHeight  = 0,
                    $module    = $(this).closest('.cc-module'),
                    sliderArgs = {};

                $('.cc-slide', this).each(function(){

                    $(this).css({
                        'visibility' : 'hidden',
                        'position'   : 'absolute'
                    });
                    var tHeight = $(this).height();

                    if(tHeight > maxHeight)
                        maxHeight = tHeight;

                    $(this).removeAttr('style');
                });

                $('.cc-slide', this).height(maxHeight);

                if($blockSliderEl.hasClass('cc-vineyards-slider')){
                    sliderArgs = {
                        before: function(slider){
                            var currSlide = slider.animatingTo;
                            $('.vineyards-slider--navigation li.active').removeClass('active');
                            $('.vineyards-slider--navigation li').eq(currSlide).addClass('active');
                        }
                    };
                }

                createFlexslider($(this), sliderArgs);
                createElouanFlexslider($(this), sliderArgs);
                createQuiltFlexslider($(this), sliderArgs);
                createNapaFlexslider($(this), sliderArgs);
            });

        }



        /*Elouan Insta Slider*/

        // function instaSlider(){



        //     var feed = new Instafeed({
        //         get: 'user',
        //         userId: '1368839344',
        //         accessToken: '1368839344.f3b0ef8.9fc769d42d3441a29845ef758ad13503',
        //         template: '<div class="cell"><a href="{{link}}" target="_blank"><div class="in" style="background-image:url(\'{{image}}\');"></div><div class="cell-hover"><span>{{likes}}</span></div></a></div>',
        //         sortBy: 'most-recent',
        //         resolution  : 'standard_resolution',
        //         limit       : 9,
        //         target      : 'instafeed',
        //         after       : function() {

        //             var slides = window.innerWidth < 600 ? 1 : ((window.innerWidth < 960) ? 3 : 5),
        //             ww = $(window).width(),
        //             slideWidth = ww/slides - 60,
        //             socialPrev = '<?xml version="1.0" encoding="UTF-8"?><svg enable-background="new 0 0 57.5 56.5" version="1.1" viewBox="0 0 57.5 56.5" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" aria-labelledby="arrowTitle arrowDesc"><title id="arrowTitle">Social Previous Arrow</title><desc id=“arrowDesc">A navigation arrow used to move social slider to the left.</desc><circle cx="29.1" cy="28.3" r="27.3" fill="#312E2F"/><g fill="none" stroke="#fff" stroke-miterlimit="10"><line x1="39.3" x2="19" y1="28.3" y2="28.3"/><polyline points="22.5 31.8 19 28.3 22.5 24.7"/></g></svg>',
        //             socialNext = '<?xml version="1.0" encoding="UTF-8"?><svg enable-background="new 0 0 57.5 56.5" version="1.1" viewBox="0 0 57.5 56.5" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" aria-labelledby="arrowTitle arrowDesc"><title id="arrowTitle">Social Next Arrow</title><desc id=“arrowDesc">A navigation arrow used to move slider to the right.</desc><circle cx="29.1" cy="28.3" r="27.3" fill="#312E2F"/><g fill="none" stroke="#fff" stroke-miterlimit="10"><line x1="19" x2="39.3" y1="28.3" y2="28.3"/><polyline points="35.8 24.7 39.3 28.3 35.8 31.8"/></g></svg>';

        //             $('.instafeed-wrapper').flexslider({
        //                 selector      : '.cc-checkerboard > .cell',
        //                 animation     : "slide",
        //                 slideshow     : false,
        //                 itemWidth     : slideWidth,
        //                 maxItems      : slides,
        //                 minItems      : 1,
        //                 controlNav    : false,
        //                 directionNav  : true,
        //                 move          : 1,
        //                 prevText      : socialPrev,
        //                 nextText      : socialNext   
        //             });
        //         }
        //     });  
        //     feed.run();
  

        // }

        /*Quiltandco Insta Slider*/
  
        function instaSliderQuiltandCo() {  



            var feed = new Instafeed({
              //   get: "user",
              //   userId: "3425874800",
              accessToken:
                "IGQWRNa1VwM3FQTVNFWUx1bGs5YzBjWmZAZAdjFmNjhKTzdycWRfRGl1NExSXy0tdThEWVU3N2RuQkJFN0FDX2VFMEQ2RDhFS211OEljcDFTUkZAkUzluVU5nanNydy1hWWc0OFpVRk00S0JOdwZDZD",
              template:
                '<div class="cell"><a href="{{link}}" target="_blank"><div class="in"><img src="{{image}}" alt="Quilt & Co. instagram picture" /></div></a></div>',
              sortBy: "most-recent",
              resolution: "standard_resolution",
              limit: 9,
              target: "instafeedQuiltandCo",
              after: function () {
                var slides =
                    window.innerWidth < 600
                      ? 1
                      : window.innerWidth < 960
                      ? 3
                      : 5,
                  ww = $(window).width(),
                  slideWidth = ww / slides - 60,
                  socialPrev =
                    '<?xml version="1.0" encoding="UTF-8"?><svg title="left carousel arrow" enable-background="new 0 0 57.5 56.5" version="1.1" viewBox="0 0 57.5 56.5" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><circle cx="29.1" cy="28.3" r="27.3" fill="#312E2F"/><g fill="none" stroke="#fff" stroke-miterlimit="10"><line x1="39.3" x2="19" y1="28.3" y2="28.3"/><polyline points="22.5 31.8 19 28.3 22.5 24.7"/></g></svg>',
                  socialNext =
                    '<?xml version="1.0" encoding="UTF-8"?><svg title="right carousel arrow" enable-background="new 0 0 57.5 56.5" version="1.1" viewBox="0 0 57.5 56.5" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><circle cx="29.1" cy="28.3" r="27.3" fill="#312E2F"/><g fill="none" stroke="#fff" stroke-miterlimit="10"><line x1="19" x2="39.3" y1="28.3" y2="28.3"/><polyline points="35.8 24.7 39.3 28.3 35.8 31.8"/></g></svg>';

                $(".instafeed-wrapper").flexslider({
                  selector: ".cc-checkerboard > .cell",
                  animation: "slide",
                  slideshow: false,
                  itemWidth: slideWidth,
                  maxItems: slides,
                  minItems: 1,
                  controlNav: false,
                  directionNav: true,
                  move: 1,
                  prevText: quiltPrev,
                  nextText: quiltNext,
                });
              },
            });
            feed.run();


        } 

        /*Quilt Insta Slider*/

        function instaSliderQuilt() {



            var feed = new Instafeed({
              //   get: "user",
              //   userId: "3425874800",
              accessToken:
                "IGQVJYeHdxUFlOS2tqalFGNHRPV2l6Umo5UlpJS1REZA18zMnRTYlUwT0xmOHFLM1gwZAmtVMktqS3FWekFabkI0T2JCTFIxY1djVDY2anUxUUprZAF9nc3JPSXNlWFlLbXpMaTNwdWl3",
              template:
                '<div class="cell"><div class="cell-inner"><a href="{{link}}" target="_blank"><div class="in" style="background-image:url(\'{{image}}\');"></div></a></div></div>',
              sortBy: "most-recent",
              resolution: "standard_resolution",
              limit: 9,
              target: "instafeedQuilt",
              after: function () {
                var slides =
                    window.innerWidth < 600
                      ? 1
                      : window.innerWidth < 960
                      ? 3
                      : 5,
                  ww = $(window).width(),
                  slideWidth = ww / slides - 60,
                  socialPrev =
                    '<?xml version="1.0" encoding="UTF-8"?><svg enable-background="new 0 0 57.5 56.5" version="1.1" viewBox="0 0 57.5 56.5" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><circle cx="29.1" cy="28.3" r="27.3" fill="#312E2F"/><g fill="none" stroke="#fff" stroke-miterlimit="10"><line x1="39.3" x2="19" y1="28.3" y2="28.3"/><polyline points="22.5 31.8 19 28.3 22.5 24.7"/></g></svg>',
                  socialNext =
                    '<?xml version="1.0" encoding="UTF-8"?><svg enable-background="new 0 0 57.5 56.5" version="1.1" viewBox="0 0 57.5 56.5" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><circle cx="29.1" cy="28.3" r="27.3" fill="#312E2F"/><g fill="none" stroke="#fff" stroke-miterlimit="10"><line x1="19" x2="39.3" y1="28.3" y2="28.3"/><polyline points="35.8 24.7 39.3 28.3 35.8 31.8"/></g></svg>';

                $(".instafeed-wrapper").flexslider({
                  selector: ".cc-checkerboard > .cell",
                  animation: "slide",
                  slideshow: false,
                  itemWidth: slideWidth,
                  maxItems: slides,
                  minItems: 1,
                  controlNav: false,
                  directionNav: true,
                  move: 1,
                  prevText: quiltPrev,
                  nextText: quiltNext,
                });
              },
            });
            feed.run();


        }

        /**
         * create the flexslider with some default values
         *
         * @param jQuery  $el   The element we're flexslider-ing
         * @param object  args  Felxslider arguments
         */
        function createNapaFlexslider($el, args){

            // This is used with the napa-slider module. After the slide changes
            // we update the custom navigation

            var onSlideChange = function(slider) {
                var nav = $el.find('[data-slide-navigation]');
                var navItem = nav.find('[data-change-slide]');
                var mobileNav = $el.find('[data-slide-mobile-navigation]');
                var mobileNavOutput = $el.find('[data-slide-mobile-navigation-output]');
                var activeClass = 'cc-napa-nav__item--active';
                if( !nav ) return; // no need to do anything if nav doesnt exist
                navItem.removeClass(activeClass).eq(slider.currentSlide).addClass(activeClass);

                // mobile only
                var selectedText = mobileNav.find('[data-change-slide]').eq(slider.currentSlide).text()
                mobileNavOutput.text(selectedText);

                if(document.querySelector('.kings-hawaiian')) {
                    var kingsSlide = document.querySelectorAll('.kings-hawaiian');
                    
                    kingsSlide.forEach(function(kingSlide) {

                        var video = kingSlide.querySelector('video');

                        if ( video ) {
                            video.pause();
                        }

                    });
                }
                
            }

            var settings = $.extend({
                selector       : '.quilt-napa-slides-container > .cc-slide-item',
                animation      : 'slide',
                animationSpeed : 600,
                slideshow      : false,
                controlNav     : false,
                touch          : true,
                prevText       : quiltPrev,
                nextText       : quiltNext,
                after          : onSlideChange
            }, args);


            $el.flexslider(settings);
        }
        function createFlexslider($el, args) {

            var settings = $.extend({
                selector: '.slides-container > .cc-slide',
                animation: 'slide',
                animationSpeed: 600,
                slideshow: false,
                controlNav: false,
                touch: true,
                prevText: prevIcon,
                nextText: nextIcon
            }, args);


            $el.flexslider(settings);
        }
        /* ELouan Flex Slider */

        function createElouanFlexslider($el, args){

            var settings = $.extend({
                selector       : '.elouan-slides-container > .cc-slide',
                animation      : 'slide',
                animationSpeed : 600,
                slideshow      : false,
                controlNav     : false,
                touch          : true,
                prevText       : elouanPrev,
                nextText       : elouanNext
            }, args);


            $el.flexslider(settings);
        }

        /* ELouan Flex Slider */

        function createQuiltFlexslider($el, args){

            var settings = $.extend({
                selector       : '.quilt-slides-container > .cc-slide',
                animation      : 'slide',
                animationSpeed : 600,
                slideshow      : false,
                controlNav     : false,
                touch          : false,
                prevText       : quiltPrev,
                nextText       : quiltNext,
            }, args);


            $el.flexslider(settings);
        }

        /* Wine Prod Flex Slider */


        /**
         * bannerSliders
         *
         * if a banner section (full-width image or banner) has more
         *  one image, it creates a autoloading slideshow
         */
        function bannerSliders(){

            $bannerSliderEl.each(function(){
                createFlexslider($(this), {});
            });
        }


        /**
         * the slider for the quick look - wines modal
         */
        function quickLookWinesSlider(){
            var $quickLookSlider = $('.quick-look-wines-slider'),
                slideWidth       = $quickLookSlider.outerWidth() / 2;

            createFlexslider( $quickLookSlider , {
                selector      : '.slides-container > .col',
                controlNav    : true,
                animationLoop : false,
                itemWidth     : slideWidth,
                maxItems      : 2,
                minItems      : 2,
                move          : 1
            });
        }
        /**
         * the slider for the vineyard Page Map
         */

        function vineyardMapSlider() {
            var vineyardContainer = (document.getElementById('vineyardContentContainer')) ? document.getElementById('vineyardContentContainer') : false;

            if (vineyardContainer) {
                var $this = vineyardContainer;
                var prev = document.getElementById('vin-prev');
                var next = document.getElementById('vin-next');
                var allSlides = $this.querySelectorAll('.vineyard-content');
                var slidesNum = allSlides.length - 1;
                var setInitHeight = function () {
                    vineyardContainer.style.height = vineyardContainer.querySelector('.vineyard-content[data-slide="' + currSlideNumber + '"]').offsetHeight;
                    vineyardContainer.style.minHeight = vineyardContainer.querySelector('.vineyard-content[data-slide="' + currSlideNumber + '"]').offsetHeight;
                }
                //default on page load
                var currSlideNumber = 0;
                var prevSlideNumber = (currSlideNumber - 1 < 0) ? slidesNum : currSlideNumber - 1;
                var nextSlideNumber = (currSlideNumber + 1 > slidesNum) ? 0 : currSlideNumber + 1;
                var activeSlide, prevSlide, nextSlide;


                var slideNum = document.getElementById('slideNumber');
                var slideTotal = document.getElementById('slideTotal');

                slideTotal.innerHTML = allSlides.length;

                // numbering on click
                var setCurrSlide = function(num) {
                    currSlideNumber = num;
                    prevSlideNumber = (num - 1 < 0) ? slidesNum : num - 1;
                    nextSlideNumber = (num + 1 > slidesNum) ? 0 : num + 1;

                    activeSlide = $this.querySelector('.vineyard-content[data-slide="' + currSlideNumber + '"]');
                    prevSlide = $this.querySelector('.vineyard-content[data-slide="' + prevSlideNumber + '"]');
                    nextSlide = $this.querySelector('.vineyard-content[data-slide="' + nextSlideNumber + '"]');

                    prevSlide.classList.add('slide-prev-ready');
                    nextSlide.classList.add('slide-next-ready');


                }

                // init on page load
                setCurrSlide(0); 
                setInitHeight();
                var updateMap = function(county) {
                    $('#map path[class], #map polygon[class], #map text[class], #map g[class]').removeClass('active');
                    $('#map path[class=' + county + '], #map polygon[class=' + county + '], #map text[class=' + county + '], #map g[class=' + county +']').addClass('active');
                }
                var isAnimating = true;

                var functionPrevNext = function (dir) {
                    isAnimating = false;
                    setCurrSlide(parseInt($this.querySelector('.vineyard-content.active').getAttribute("data-slide")));
                    if (dir == 'next') {

                        //slide right

                        activeSlide.classList.add('slide-next');

                        nextSlide.classList.add('active');

                        slideNum.innerHTML = parseInt(nextSlide.getAttribute('data-slide')) + 1;

                        updateMap(nextSlide.getAttribute("data-county"));

                        setTimeout(function() {
                            activeSlide.classList.remove('active', 'slide-next');
                            prevSlide.classList.remove('slide-prev-ready');
                            nextSlide.classList.remove('slide-next-ready');
                            var newHeight = $this.querySelector('.vineyard-content[data-slide="' + nextSlideNumber + '"]').offsetHeight;
                            setCurrSlide(nextSlideNumber);


                            vineyardContainer.style.height = newHeight + 'px';
                            vineyardContainer.style.minHeight = newHeight + 10 + 'px';

                            isAnimating = true;
                        }, 500);

                    } else {
                        //slide left

                        activeSlide.classList.add('slide-prev');
                        prevSlide.classList.remove('slide-prev-ready');
                        nextSlide.classList.remove('slide-next-ready');
                        prevSlide.classList.add('active');
                        slideNum.innerHTML = parseInt(prevSlide.getAttribute('data-slide') ) + 1;
                        updateMap(prevSlide.getAttribute("data-county"));
                        setTimeout(function () {
                            activeSlide.classList.remove('active', 'slide-prev');

                            var newHeight = $this.querySelector('.vineyard-content[data-slide="' + prevSlideNumber + '"]').offsetHeight;
                            setCurrSlide(prevSlideNumber);
                            vineyardContainer.style.height = newHeight + 'px';
                            vineyardContainer.style.minHeight = newHeight + 10 + 'px';
                            isAnimating = true;
                        }, 500);

                    }
                }

                prev.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (isAnimating) {
                        functionPrevNext('prev');
                    }

                });

                next.addEventListener('click', function(e) {
                    e.preventDefault();
                    if (isAnimating) {
                        functionPrevNext('next');
                    }
                });

            }


        }
        /**
         * initAll
         *
         * initialize all the sliders in this module
         */
        function initAll(){ 
            blockSliders();
            bannerSliders();

            // var targetInsta = document.getElementById('instafeed');
            // if (targetInsta) {
            //   instaSlider();
            // }
            var targetInstaQuilt = document.getElementById('instafeedQuilt');
            if (typeof targetInstaQuilt != 'undefined' && targetInstaQuilt) {
                instaSliderQuilt();
                //console.log("quilt insta");
            }
            var targetInstaQuiltandCo = document.getElementById('instafeedQuiltandCo');
            if (typeof targetInstaQuiltandCo != 'undefined' && targetInstaQuiltandCo) {
                instaSliderQuiltandCo();
                
            }
            
            quickLookWinesSlider();
            vineyardMapSlider();
            //
            // vineyards mobile nav
            //
            $('.vineyards-slider--navigation li').on('click', function(event) {
                event.preventDefault();
                var index  = $(this).index(),
                    slider = $(this).closest('ul').siblings('.cc-slider').data('flexslider');

                slider.flexAnimate(index);
            });

            // napa slider (quilt) navigation events
            // when using a napa slider module, it displays custom navigation.

            $("[data-change-slide]").on('click', function (e) {
                var self = $(this);
                var index = self.data('change-slide');
                var slider = self.parents('.cc-slider');

                slider.flexslider(index);
                e.preventDefault();
            });

            // Napa Slider Mobile Nav
            var container      =  $('[data-slide-mobile-navigation]');
            var output         =  $('[data-slide-mobile-navigation-output]');
            var outputIcon     =  $('[data-slide-mobile-navigation-icon]');
            var dropdown       =  $('[data-slide-mobile-navigation-dropdown]');

            output.on('click', function(e) {
                dropdown.find('[data-change-slide]').each(function() {
                    var self = $(this);
                    self.text().trim() === output.text().trim() ? self.hide() : self.show();
                });

                dropdown.slideToggle();

                outputIcon.toggleClass('cc-napa-nav-mobile__icon--down').find('.quilt-chevron').toggleClass('quilt-chevron--down');
            });

            dropdown.find('[data-change-slide]').on('click', function(e) {
                var selectedText = $(this).text();
                output.text(selectedText)
                dropdown.slideToggle();
            });
        }

        return {
            initAll             : initAll,
            blockSliders        : blockSliders,

            bannerSliders       : bannerSliders,
            createFlexslider    : createFlexslider,
            
            instaSliderQuilt    : instaSliderQuilt,
            instaSliderQuiltandCo : instaSliderQuiltandCo
            //instaSlider      : instaSlider
        };

    })(); // sliders

    window.COPPERCANE.sliders = sliders;

    /**
     * Confirms the transient has been written
     */
    function ajaxConfirmTransient() {
        console.log("Instagram data cached.");
    }

    /*Elouan Flexslider*/

    function flexElouanSlider() {
        
        var slides = window.innerWidth < 600 ? 1 : ((window.innerWidth < 960) ? 3 : 5),
            ww = $(window).width(),
            slideWidth = ww / slides - 60,
            socialPrev = '<div class="slick-prev slick-arrow"><?xml version="1.0" encoding="UTF-8"?><svg enable-background="new 0 0 57.5 56.5" version="1.1" viewBox="0 0 57.5 56.5" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" aria-labelledby="arrowTitle arrowDesc"><title id="arrowTitle">Social Previous Arrow</title><desc id=“arrowDesc">A navigation arrow used to move social slider to the left.</desc><circle cx="29.1" cy="28.3" r="27.3" fill="#312E2F"/><g fill="none" stroke="#fff" stroke-miterlimit="10"><line x1="39.3" x2="19" y1="28.3" y2="28.3"/><polyline points="22.5 31.8 19 28.3 22.5 24.7"/></g></svg></div>',
            socialNext = '<div class="slick-next slick-arrow"><?xml version="1.0" encoding="UTF-8"?><svg enable-background="new 0 0 57.5 56.5" version="1.1" viewBox="0 0 57.5 56.5" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" aria-labelledby="arrowTitle arrowDesc"><title id="arrowTitle">Social Next Arrow</title><desc id=“arrowDesc">A navigation arrow used to move slider to the right.</desc><circle cx="29.1" cy="28.3" r="27.3" fill="#312E2F"/><g fill="none" stroke="#fff" stroke-miterlimit="10"><line x1="19" x2="39.3" y1="28.3" y2="28.3"/><polyline points="35.8 24.7 39.3 28.3 35.8 31.8"/></g></svg></div>';
            
        // $('.instafeed-wrapper').flexslider({
        //     selector: '.cell',
        //     animation: "slide",
        //     slideshow: false,
        //     itemWidth: slideWidth,
        //     maxItems: slides,
        //     minItems: 1,
        //     controlNav: false,
        //     directionNav: true,
        //     move: 1,
        //     prevText: socialPrev,
        //     nextText: socialNext
        // });
        $('.instafeed-wrapper').slick({
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            slidesToShow: 5,
            prevArrow: socialPrev,
            nextArrow: socialNext, 
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 920,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true
                    
                }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true
                     
                    
                }
            }
            ]
        });
    }


    /**
     * Layout for the single instagram section
     */
    function singleElouanInstagram() {  
         
        $('.cc-elouaninsta').each(function () {
            var $postContainer = $(this);
            if ($postContainer.hasClass('single-insta--fromcache')) {
                flexElouanSlider();
                return true;
            }

            var feed = new Instafeed({
              // get: 'user', 
              // userId: '1368839344',
              accessToken:
                "IGQWRPWnNTbGdnY2tQaGZAOa1BKaTNWbEF0WDJEbG9pUmFTeU5XWm1aQTdjb1ljYk41cEFXeUFGSXhLUXJxSVJfSTVhcmUydjVHNnRkeGVxY0pxd1IzUjBtZAnc0Q19YcG1nejZAOdkw2N2drdwZDZD",
              template:
                '<div class="cell"><a href="{{link}}" target="_blank"><div class="in"><img src="{{image}}" alt="Elouan instagram picture" /></div></a></div>',
              //template: '<div class="cell"><a href="{{link}}" target="_blank"><img class="in" src="{{image}}" /><div class="cell-hover"><span>{{likes}}</span></div></a></div>',
              sortBy: "most-recent",
              resolution: "standard_resolution",
              limit: 9,
              target: "instafeed",
              error: function () {
                deferred.resolve();
              },
              after: function () {
                //cacheFeedMarkup($postContainer.html());
                flexElouanSlider();
              },
            });
            feed.run();

        });



        /**
         * Set up an ajax request to save the insfeed markup
         *
         * @param string  markup  The markup to save to the transient
         */
        function cacheFeedMarkup(markup) {
            if (!cc_ajax || !cc_ajax.ajaxurl) {
                return false;
            }
            
            $.ajax({
                url: cc_ajax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'elouan_ajax_save_single_instagram_markup',
                    markup: encodeURIComponent(markup),
                }
            }).done(ajaxConfirmTransient).fail(ajaxError);
        }

    }


    /**
     * ux
     *
     * things to drive user interactions and experience for the site,
     *  like plugins for elements and general event listeners
     */
    var ux = (function(){

        var $body         = $('body'),
            $selects      = $('.cc-select'),
            $videos       = $('.video-background, .secondary-content .river--video-background'),
            $fadeInHeader = $('.fade-in-header').not('.cc-solid-header'),
            $promoBanner  = $('.sk-promo-banner');

        //
        // PUBLIC
        //

        /**
         * init
         */
        function init(){

            var $window = $(window);

            initPlugins();

            eventListeners();

            vineyardsGraphicListeners();

            growerGraphicListeners();

            svgGraphicHovers();

            if($window.height() < 500 ){
                hideHeaderScroll();
            } else if( $fadeInHeader.length > 0 || $promoBanner.length > 0 ){
                scrolledFromTop();
                $window.trigger('scroll');
            }

            homepageBannerFadetext();

            carne_wineClubSelect();
            carne_mapPage();


            bannerRuleFade();

            avrae_landingVideo();

            // shortcodes
            cc_openable();
        }


        //
        // PRIVATE
        //

        /**
         * initPlugins
         */
        function initPlugins(){

            //
            // background videos
            //
            if( ! isMobile ){
                $videos.bigvideo();
            }


            //
            // dropkick
            //
            $selects.dropkick();


            //
            // ajaxchimp
            //
            $('.cc-mailchimp').ajaxChimp({
                callback: function(resp){
                    var msg = resp.msg;
                    if(resp.result === 'success'){

                        modals.create('<header class="modal-header"><h4>Successfully Subscribed</h4></header><div class="modal-main">' + msg + '</div>');
                        $('.mailing-list-signup input[type="email"]').val('');
                    }
                    /*if(resp.result === 'error'){
                        var sub = "0 -";
                        if ( msg.indexOf(sub) !== -1 ) {
                            txtMsg = msg.split('-');
                            msg = txtMsg[1];
                        }
                        modals.create('<header class="modal-header"><h4>Our Apologies</h4></header><div class="modal-main">' + msg + '</div>');
                    }*/
                }
            });

        }


        /**
         * eventListeners
         *
         * init the event listeners for general interactions
         */
        function eventListeners(){

            //
            // anchors 
            //
            $('a[href="#"], .svg-anchor, .svg-navigate-to').on('click', function(event) {
                event.preventDefault();

                var href = $(this).attr('xlink:href') ? $(this).attr('xlink:href') : $(this).attr('href'),
                    $el  = $(href);

                //
                // @todo - i'm not entirely sure this was here...can be
                //  removed after confirming it doesn't do anything
                //
                // $('html').removeClass('mobile-menu--active');
                //

                if( href !== '#' && $el.length > 0 ){
                    
                    var offset = $el.offset().top;
                    $('body, html').animate({
                        scrollTop: offset + 'px'
                    });
                }
            });


            //
            // Quilt Vineyards Map Slider
            //


            $('#map path[class], #map polygon[class]').hover(

                function() {

                    var theMap = $('svg#map');
                    var classMatch = $(this).attr('class');
                    theMap.find('text.' + classMatch + ', g.' + classMatch).addClass('active');
                },
                function() {
                    var theMap = $('svg#map');
                    var classMatch = $(this).attr('class');
                    theMap.find('text.' + classMatch + ', g.' + classMatch).removeClass('active');
                }
            );

            $('#map path[class], #map polygon[class], #map text[class], #map g[class]').on('click', function (e){

                e.preventDefault();
                if ($(this).hasClass('active')) {
                    return;
                 } else {
                    var county = $(this).attr('class'),
                    container = $(this).closest('.cc-vineyards-page'),
                    vinCont = container.find('.vineyards-container'),
                    vinContEach = container.find('.vineyard-content'),
                    activeVin = container.find('.vineyard-content.active'),
                    newVin = container.find('.vineyard-content[data-county="' + county + '" ]'),
                    vinHeight = newVin.height(),
                    prevSlide, nextSlide;

                    vinContEach.removeClass('active slide-active slide-prev-ready slide-next-ready');
                    activeVin.addClass('slide-out');

                    $('#map path[class], #map polygon[class], #map text[class], #map g[class]').removeClass('active');

                    $('#map path[class="' + county + '"], #map polygon[class="' + county + '"], #map text[class="' + county + '"], #map g[class="' + county + '"]').addClass('active');

                     setTimeout(function(){
                        activeVin.removeClass('active slide-out');
                        newVin.addClass('active');

                        //set prev / next in slider to keep continuity when toggling between map clicks and arrows
                        var num = newVin.data('slide');
                        var slidesNum = vinContEach.length;
                        var prevSlideNumber = (num - 1 < 0) ? slidesNum : num - 1;
                        var nextSlideNumber = (num + 1 > slidesNum) ? 0 : num + 1;

                        prevSlide = container.find('.vineyard-content[data-slide="' + prevSlideNumber + '"]');
                        nextSlide = container.find('.vineyard-content[data-slide="' + nextSlideNumber + '"]');

                        prevSlide.addClass('slide-prev-ready');
                        nextSlide.addClass('slide-next-ready');

                        $('#slideNumber').text(newVin.data('slide') + 1);
                        vinCont.height(vinHeight);
                     }, 300);
                 }

            });



            $('#map text[class], #map g[class]')
                .mouseover(function () {
                    var className = $(this).attr('class');

                    $('#map path[class="' + className + '"], #map polygon[class="' + className + '"]').css({
                        'fill': '#808080'
                    });


                })
                .mouseout(function () {
                    var className = $(this).attr('class');

                    $('#map path[class="' + className + '"], #map polygon[class="' + className + '"]').css({
                        'fill': ''
                    });


            });

            //
            // nav items with subitems
            //
            $('.cc-main-nav .menu-item-has-children > a[href="#"]').on('click', function(event) {
                // just prevent them from going anywhere
                event.preventDefault();
            });



            //
            // expandable copy
            //
            $('.js-expand-copy').on('click', function(event) {
                event.preventDefault();
                var $parent   = $(this).toggleClass('active').closest('.expandable-container'),
                    $siblings = $parent.siblings('.expandable-container');

                $('.expandable-content', $parent).slideToggle();

                $('.js-expand-copy', $siblings).removeClass('active');
                $('.expandable-content', $siblings).slideUp();
            });


            //
            // vineyard module modal
            //
            $('.js-trigger-vineyard-modal').on('click', function(event) {
                event.preventDefault();
                var $el     = $(this),
                    $parent = $el.closest('.cc-slide').children('.cc-slide--image');

                $parent.addClass('modal-open');
                $parent.find('.vineyard--location svg').css({
                    'maxHeight': ($parent.height() - 60) + 'px'
                });
            });
            $('.cc-slide').on('click', '.vineyard-modal .ico--close', function(event) {
                event.preventDefault();
                var $modal = $(this).closest('.modal-open').removeClass('modal-open');
            });



            //
            // jobs module
            //
            $('.cc-job-header h5').on('click', function(event) {
                event.preventDefault();
                if($(this).hasClass('active')) {
                    $(this).removeClass('active');
                    $(this).parent().next('.job-description').hide();
                } else {
                    $(this).addClass('active');
                    $(this).parent().next('.job-description').show();
                }
            });


            //
            // mobile expand
            //
            $('.footer-mid h5').on('click', function(event) {
                event.preventDefault();
                $(this).toggleClass('active');
            });


            //
            // mobile menu
            //
            $('.mobile-menu-trigger').on('click', function(event) {
                event.preventDefault();

                var $html = $('html'),
                    $menu = $(this).siblings('nav').children('ul');

                setDrawerDimensions();

                $html.toggleClass('mobile-menu--active');

                if($html.hasClass('brand-dropdown--active')){
                    $html.removeClass('brand-dropdown--active');
                    $('.mobile-drawer').removeClass('active');
                }

                if($menu.find('.mobile-login-link').length === 0){
                    var $loginLink = $('.cc-action-menu .cc-log-in').clone();

                    $('<li class="mobile-login-link"/>').append( $loginLink ).appendTo($menu);
                }
            });


            //
            // open / close the brand dropdown
            //
            $('.js-toggle-brand-dropdown').on('click touchstart', function(event) {
                event.preventDefault();

                var $html = $('html');

                setDrawerDimensions();

                if($html.hasClass('brand-dropdown--active')){
                    $('.js-trigger-drawer-back').trigger('click');
                }

                if( $html.hasClass('mobile-menu--active') ){
                    $html.removeClass('mobile-menu--active');
                }

                if( $(window).scrollTop() < 100 ){
                    var $header = $('.cc-header.fade-in-header');

                    if($html.hasClass('brand-dropdown--active')){
                        $header.removeClass('header--background');
                    } else {
                        $header.addClass('header--background');
                    }
                }

                $('html').toggleClass('brand-dropdown--active');
            });

            $.fn.scrollTo = function (settings) {
                var _el = $(this);
                var _settings = $.extend({ speed: 1000, offset: 0, callback: null }, settings);
                var _headerOffset = $(".cc-header").height();

                $('html, body').animate({
                    scrollTop: (_el.offset().top - _headerOffset - _settings.offset),
                }, _settings.speed, _settings.callback);
            };
            //
            // open / close the Product More Details
            //


            $('.product-detail-header').on('click', function() {
                $(this).toggleClass('open');
                $(this).next('.more-detail__content-container').slideToggle();

                var _this = $(this);
                setTimeout(function () {
                    _this.scrollTo({ speed: 600, offset: 5 });
                }, 100);
            });
            $('.close-more-less').on('click', function() {

                var parentDiv = $(this).parents('.product-more-detail');
                var this_scrollTo = $(this).parents('.product--wine-text');

                parentDiv.find('.product-detail-header').toggleClass('open');
                parentDiv.find('.more-detail__content-container').slideToggle();

                setTimeout(function() {
                    this_scrollTo.scrollTo({ speed: 600, offset: 0 });
                }, 100);
            });
            //
            // mobile slider for the mailing list
            //

            var ajaxChimp_d = false;
            $('.cc-brand-dropdown .mailing-list-signup-label').on('click touchstart', function(event) {
                event.preventDefault();

                var ww = $(window).width();

                if( ww < 941 ){

                    var $mobileDrawer = $('.mobile-drawer')

                    if( $mobileDrawer.length == 0 ){

                        var html = $(this).closest('li').html();

                        $mobileDrawer = $( '<div class="mobile-drawer"><a href="#" class="js-trigger-drawer-back"><span class="ico ico--dir--left">' + svg_back + '</span> Back</a><div class="drawer-content">' + html + '</div></div>' ).appendTo('body');
                    }

                    setTimeout(function(){
                        $mobileDrawer.addClass('active');
                    });


                    if( ! ajaxChimp_d && ! isMobile){
                        ajaxChimp_d = true;
                        $('.mobile-drawer .cc-mailchimp').ajaxChimp({
                            callback: function(resp){
                                var msg = resp.msg;

                                if(resp.result === 'success'){
                                    modals.create('<header class="modal-header"><h4>Successfully Subscribed</h4></header><div class="modal-main">' + msg + '</div>');
                                    $('.mailing-list-signup input[type="email"]').val('');
                                }
                                /*if(resp.result === 'error'){
                                    var sub = "0 -";
                                    if ( msg.indexOf(sub) !== -1 ) {
                                        txtMsg = msg.split('-');
                                        msg = txtMsg[1];
                                    }
                                    modals.create('<header class="modal-header"><h4>Our Apologies</h4></header><div class="modal-main">' + msg + '</div>');
                                }*/
                            }
                        });
                    }
                }
            });


            //
            // drawer back
            //
            $('body').on('click touchstart', '.js-trigger-drawer-back', function(event) {
                event.preventDefault();

                var $drawer = $('.mobile-drawer').removeClass('active');

                setTimeout(function(){
                    $drawer.remove();
                }, 400);
            });


            //
            // cart quantity
            //
            $('.cc-cart-quantity').on('change', function(event) {
                event.preventDefault();

                var $t            = $(this),
                    $parent       = $t.closest('.cc-purchasing-options'),
                    $input        = $parent.find('.cc-cart-quantity-input'),
                    $otherSelect  = $parent.find('select.cc-cart-quantity').not($t),
                    isCase        = $t.closest('.quantity-select').hasClass('cc-cart--case-select'),
                    numberInCase  = $parent.closest('.cc-product').hasClass('cc-case-of-6') ? 6 : 12;
                    thisQuantity  = isCase ? $t.val() * numberInCase : $t.val(),
                    otherQuantity = isCase ? $otherSelect.val() : $otherSelect.val() * numberInCase,
                    finalQuantity = parseInt(thisQuantity) + parseInt(otherQuantity);

                $input.val(finalQuantity);
            });

        } // event listeners



        /**
         * vineyardsGraphicListeners
         *
         * all the setup for the vineyards graphic map
         *  - on Meiomi
         */
        function vineyardsGraphicListeners(){

            $('.vineyard--location .svg-anchor').on('mouseover', function(event) {
                event.preventDefault();
                var county  = $(this).data('county'),
                    offsetX = county === 'Sonoma County' ? -90 : -70,
                    offsetY = event.offsetY - 10;

                $('<span style="display:none;left:' + offsetX + 'px; top:' + offsetY + 'px" class="county-hover-name">' + county + '</span>')
                    .appendTo($(this).closest('.vineyard--location')).fadeIn(200);
            });
            $('.vineyard--location .svg-anchor').on('mouseout', function(event) {
                event.preventDefault();
                $(this).closest('.vineyard--location').find('.county-hover-name').fadeOut(200, function(){
                    $(this).remove();
                });
            });

            // navigate around the slider when the graphic is clicked
            $('.cc-vineyards .svg-anchor, .cc-vineyards .svg-navigate-to').on('click', function(event) {
                event.preventDefault();

                var href       = $(this).attr('xlink:href').replace('#', ''),
                    $newSlide  = $('.cc-vineyards .cc-slide--image[data-slide="' + href + '"]').closest('.cc-slide'),
                    slideIndex = $newSlide.data('index'),
                    slider     = $(this).closest('.cc-vineyards-slider').data('flexslider');

                slider.flexAnimate(slideIndex);
                $('.js-trigger-vineyard-modal', $newSlide).trigger('click');
            });
        }



        /**
         * growerGraphicListeners
         *
         * all the setup for the growers graphic
         *  - on Beran
         */
        function growerGraphicListeners(){
            //
            // grower page navigation
            //
            $('.growers-page-navigation .js-trigger-grower-graphic').on('click', function(event) {
                event.preventDefault();
                var $self  = $(this),
                    grower = $self.data('grower'),
                    $el    = $('#' + grower);

                if( $el.length > 0 ){
                    var offset = $el.offset().top;
                    $('body, html').animate({
                        scrollTop: offset + 'px'
                    });
                }
            });

        }


        /**
         * svgGraphicHovers
         *
         * handle mouseover/mouseout for things
         */
        function svgGraphicHovers(){
            $('.js-svg-hover').on('mouseover', function(event) {
                event.preventDefault();
                var nicename = $(this).data('nicename'),
                    offsetX  = event.offsetX - 20,
                    offsetY  = event.offsetY - 10;
                $('<span style="display:none;left:' + offsetX + 'px; top:' + offsetY + 'px" class="graphic-hoverable"><span>' + nicename + '</span></span>')
                    .appendTo($(this).closest('.svg-hover-container')).fadeIn(200);
            });
            $('.js-svg-hover').on('mouseout', function(event) {
                event.preventDefault();
                $(this).closest('.svg-hover-container').find('.graphic-hoverable').fadeOut(200, function(){
                    $(this).remove();
                });
            });
        }



        /**
         * hideHeaderScroll
         *
         * if we're on a very small device, hide the header on scroll down
         * @param name paramter description
         */
        function hideHeaderScroll(name){
            var $element        = $('.cc-header'),
                elHeight        = $element.outerHeight(),
                elTop           = 0,
                $document       = $( document ),
                dHeight         = $document.height(),
                $window         = $( window ),
                wHeight         = $window.height(),
                wScrollCurrent  = 0,
                wScrollBefore   = 0,
                wScrollDiff     = 0;

            if( !$element.length ) return true;

            $window.on( 'scroll', function(){
                wScrollCurrent  = $window.scrollTop();
                wScrollDiff     = wScrollBefore - wScrollCurrent;
                elTop           = parseInt( $element.css( 'top' ) ) + wScrollDiff;

                if( wScrollCurrent <= 0 ) // scrolled to the very top; element sticks to the top
                    $element.removeClass( 'hide' );

                else if( wScrollDiff > 0 ) // scrolled up; element slides in
                    $element.removeClass( 'hide' );

                else if( wScrollDiff < 0 ) { // scrolled down
                    if( wScrollCurrent + wHeight >= dHeight - elHeight )  // scrolled to the very bottom; element slides in
                        $element.removeClass( 'hide' );

                    else // scrolled down; element slides out
                        $element.addClass( 'hide' );
                }

                wScrollBefore = wScrollCurrent;
            });

        }


        /**
         * scrolledFromTop
         *
         * scroll, check to see if we should add a background color
         *  to the header nav (ie on Beran)
         */
        function scrolledFromTop(){

            var elClassActive = 'header--background',
                $window       = $( window ),
                $html         = $('html');

            $window.on( 'scroll', function() {
                var wScrollCurrent = $window.scrollTop();

                if( wScrollCurrent > 100 ){
                    $html.addClass('cc-minify-nav');
                    $fadeInHeader.addClass( elClassActive );
                } else {
                    $html.removeClass('cc-minify-nav');
                    $fadeInHeader.removeClass( elClassActive );
                }

            });
        }

        /**
         * homepageBannerFadetext
         *
         * fade in the text in the homepage banner
         */
        function homepageBannerFadetext(){
            var $spans = $('.home .cc-page-banner-wrapper h2 span, .home .cc-page-banner-wrapper h1 span'),
                timer,
                index = 0;

            if($spans.length > 0){
                fadeInterval();
                timer = setInterval( fadeInterval, 1000);
            }

            function fadeInterval(){
                $spans.eq(index).addClass('visible');
                index++;

                if(index === $spans.length){
                    clearInterval(timer);
                }
            }
        }


        /**
         * carne_wineClubSelect
         *
         * choose the wine club link for the user based on their selections
         */
        function carne_wineClubSelect(){
            var $link       = $('#carne--join-wine-club-cta'),
                $quantities = $('.carne-club-quantity input[type="radio"]'),
                $styles     = $('.carne-club-styles input[type="radio"]');

            $quantities.on('change', function(event) {
                event.preventDefault();

                var style = $styles.filter(':checked').val(),
                    url   = $(this).data(style);

                if(url)
                    $link.attr('href', url);
            });
            $styles.on('change', function(event) {
                event.preventDefault();
                $quantities.filter(':checked').trigger('change');
            });

            $quantities.filter(':checked').trigger('change');

        }


        /**
         * carne_mapPage
         *
         * the map page gallery
         */
        function carne_mapPage(){
            $('.cc-map-gallery-image').on('click', function(event) {
                event.preventDefault();
                var fullUrl = $(this).data('full'),
                    caption = $(this).data('caption'),
                    markup  = '<div class="map-full-img"><img src="' + fullUrl + '"></div>';

                if(caption)
                    markup += '<div class="map-caption">' + caption + '</div>';

                modals.create(markup, 'map-modal');
            });
        }



        /**
         * bannerRuleFade
         *
         * move the banner rules based on scroll position
         */
        function bannerRuleFade(){
            var $bannerRules = $('.banner-rules');
            if( $bannerRules.length > 0 ){
                setTimeout(function(){
                    $bannerRules.addClass('load-in run-rules').removeClass('init-load-in');
                }, 500);
            }
        }


        /**
         * play the avrae landing page video, which transitions into
         *  the banner image
         */
        function avrae_landingVideo(){

            if( typeof videojs === "function" && $('#video-avrae-landing').length > 0 ){
                var $container = $('#avrae--landing-video'),
                    $video     = $('video', $container),
                    vidWidth   = $(window).width(),
                    vidHeight  = vidWidth * .5625,
                    $slides    = $('.landing-slides', $container);

                var player = videojs( 'video-avrae-landing', {
                    width    : vidWidth,
                    height   : vidHeight,
                    children : {
                        posterImage       : false,
                        textTrackDisplay  : false,
                        bigPlayButton     : false,
                        errorDisplay      : false,
                        textTrackSettings : false,
                        controlBar : {
                            children : false
                        }
                    }
                }, function() {
                    this.play();

                    $container.addClass('activate-slides');
                });
            }
        }


        /**
         * Openable shortcode
         */
        function cc_openable(){
            $('.cc-openable').each(function(){
                var $openable = $(this),
                    $trigger  = $('.cc-openable__trigger', $openable);

                $trigger.on('click', function(event) {
                    event.preventDefault();

                    $(this).toggleClass('trigger--active');
                    $('.cc-openable__content', $openable).slideToggle();
                });
            });
        }

        return {
            init: init
        };
    })(); // ux





    var parallax = (function(){

        var wh                = $(window).height(),
            $parallaxers      = $('.cc-fullwidth-image, .cc-section-banner, .cc-page-banner-wrapper, .cc-wine-club-promo, .cc-section-banner__white-cta'),
            $vineyardsZoomers = $('.vineyard-content .vineyard-img-zoom');


        /**
         * inViewport
         *
         * checks to see if the given element is in the viewport
         * @param el // the element
         */
        function inViewport(el){
            var scrollTop = $(window).scrollTop(),
                offset    = $(el).offset().top;

            if( (scrollTop > offset - wh) && (scrollTop < offset + wh) ) {
                return scrollTop - offset;
            } else {
                return false;
            }
        }

        /**
         * doParallax
         *
         * do the parallax action
         */
        function doParallax(){
            $parallaxers.each(function(i, el){

                var $parallaxEl    = $('.parallax-el', el),
                    $fadeCta       = $('.parallax-fade', el),
                    scroll         = inViewport(el),
                    scrollRatio    = window.PARALLAX_SPEED || -.1;

                if( scroll ){

                    var ratio = scroll / wh;

                    $('.banner--fixed:not(.video-background)', el).css({
                        'backgroundPosition' : 'center ' + (scroll * scrollRatio) + 'px'
                    });

                    if( ratio > -.4 && ratio < .2){
                        $fadeCta.addClass('visible');
                    } else {
                        $fadeCta.removeClass('visible');
                    }
                }
            });
        }



        /**
         * doVineyardZoom
         *
         * zoom into the vineyard things
         */
        var doVineyardZoom = debounce(function(){

            $vineyardsZoomers.each(function(i, el){
                var scroll = inViewport(el);

                if(scroll){
                    var ratio = scroll / wh;

                    if(ratio > -.4 && ratio < .2){
                        $(el).addClass('zoomed');
                    } else {
                        $(el).removeClass('zoomed');
                    }
                }
            });
        }, 100);



        //
        // PUBLIC
        //

        /**
         * init
         */
        function init(name){

            $('.cc-module:first-child, .cc-page-banner-wrapper').find('.parallax-fade').addClass('visible');

            if( ! isMobile ){

                if( $parallaxers.length > 0 ){
                    $('body').addClass('parallax-engage');
                    $(window).on('scroll', doParallax);
                }

                if( $vineyardsZoomers.length > 0 ){
                    $(window).on('scroll', doVineyardZoom);
                }
            }
        }



        return {
            init: init
        }

    })(); // parallax




    var grappos = (function(){

        /**
         * init
         *
         * init the grappos
         */
        function init(){

            $('body').on('cc-modal-load', '.modal-wrapper', function(){
                var $loaderContainer = $('.modal-content', this);
                loader.init( $loaderContainer );
                // $.getScript('//www.grappos.com/rwidget/js/load.js', function(){
                //     loader.destroy( $loaderContainer );
                // });
                loader.destroy($loaderContainer);
            });


            //
            // event listener to engage the grappos
            //
            $('.js-init-grappos').on('click', function(event) {
                event.preventDefault();
                openGrapposModal();
            });


            $(window).on('hashchange', function(event) {
                if( window.location.hash === '#retail-locator'){
                    openGrapposModal();
                }
            }).trigger('hashchange');

        }


        /**
         * Opens the grappos modal
         */
        function openGrapposModal(){
            // if( window.grapposConfig === undefined){

            //     if(window.grapposUid === undefined){
            //         window.grapposUid = 'Cz-861275013';
            //     }

            //     window.grapposConfig = {
            //         uid     : window.grapposUid,
            //         theme   : 'silver'
            //     };

            //     // bkgdClr   : '#fff',
            //     // txtClr    : '#000',
            //     // autoHover : '#aaa',
            //     // resHover  : '#aaa',

            //     modals.createPersistent('<div id="grappos-widget" style="width: 100%; height: 480px;"></div>', 'grappos-modal');
            // } else {
            //     modals.createPersistent('<div id="grappos-widget" style="width: 100%; height: 480px;"></div>', 'grappos-modal');
            //     $('#cc-modal--grappos-modal').addClass('visible');
            // }

            //modals.createPersistent('<div id="grappos-widget" style="width: 100%; height: 480px;"></div>', 'grappos-modal');
            $('#cc-modal--grappos-modal').addClass('visible');
            $('html').addClass('cc-fixed-scroll');
        }

        return {
            init: init
        };
    })(); // grappos





    var modals = (function(){

        var closeMarkup = '<span class="ico ico--close">' + svg_close + '</span>';


        /**
         * createPersistentModal
         *
         * create a persistent modal (like grappos) that stays on the
         *  page once its ont he page
         * @param modalContent // the modal html
         * @param modalId      // we need an ID
         */
        function createPersistentModal(modalContent, modalId){
            var $modal = $('<div id="cc-modal--' + modalId + '" class="modal-wrapper modal--persistent" />').appendTo('body');

            $modal.append('<div class="modal-content">' + closeMarkup + modalContent + '</div>').trigger('cc-modal-load');

            setTimeout(function(){
                $modal.addClass('visible');
            }, 0);
        }



        //
        // PUBLIC
        //

        /**
         * createModal
         *
         * create the overall modal markup and attach to the body for display
         * @param modalContent // (string) the html of the modal
         */
        function createModal(modalContent, modalClasses){

            var $modal   = $('#cc-modal'),
                _classes = modalClasses !== undefined ? ' ' + modalClasses : '';

            // setup
            if( $modal.length > 0 ){
                $('.modal-content', $modal).removeClass().addClass('modal-content' + _classes).empty().html(closeMarkup + modalContent);
            } else {
                $modal = $('<div id="cc-modal" class="modal-wrapper" />').appendTo('body');
                $modal.append( '<div class="modal-content' + _classes + '">' + closeMarkup + modalContent + '</div>' );
            }
            setTimeout(function(){
                $modal.addClass('visible');
            }, 10);
        }


        /**
         * close
         *
         * close the modal
         */
        function close( event ){
            if(event)
                event.preventDefault();

            var $modal = $('.modal-wrapper').removeClass('visible');
            $('.playable', $modal).remove();
            $('html').removeClass('cc-fixed-scroll');
            $('body').trigger('modal.close');
        }


        /**
         * init
         */
        function init(){

            //
            // launch the regular modal
            //
            $('.js-launch-modal').on('click', function(event) {
                event.preventDefault();
                var modal        = $(this).data('modal'),
                    modalContent = $('#' + modal).html();

                createModal(modalContent);
            });


            //
            // close the modal
            //
            $('body').on('click', '.modal-content .ico--close', close);
        }

        return {
            init             : init,
            create           : createModal,
            createPersistent : createPersistentModal,
            close            : close
        };

    })(); // modals
    COPPERCANE.modals = modals;



    var form = (function(){

        var $forms = $('.cc-form'),
            proxy  = '/wp-content/themes/coppercane/inc/proxy.php';


        /**
         * validateForm
         *
         * validate the given form
         * @param $form // the form
         */
        function validateForm($form){
            var valid     = true,
                $required = $('input.required', $form).removeClass('input-error');

            $required.each(function(){
                var $el = $(this);
                if($el.val() === ''){
                    var msg = $el.data('error');
                    valid = false;
                    $el.addClass('input-error').before('<label class="form-msg form-msg--error">' + msg + '</label>');
                }
            });

            return valid;
        }


        /**
         * processForm
         *
         * process the form
         * @param $form // the form
         */
        function processForm($form){
            var action           = $form.attr('action'),
                submitData       = $form.serialize(),
                $loaderContainer = $('#cc-modal .modal-content'),
                ajaxData         = {
                    action : 'cc_ajax_login_user',
                    proxy  : action + '?' + submitData
                };

            loader.init( $loaderContainer );

            $.ajax({
                url: cc_ajax.ajaxurl,
                data: ajaxData,
                error: ajaxError,
                success: function(data, textStatus, jqxhr) {
                    var json;

                    try{
                        json = JSON.parse(data);

                        console.log(json);
                    } catch(e){
                        console.error(e);
                        json = null;
                        $form.prepend('<label class="form-msg form-msg--error">' + data + '</label>');
                    }

                    if(json){
                        if(json.err_msg === ''){
                            location.reload();
                        } else {
                            $form.prepend('<label class="form-msg form-msg--error">' + json.err_msg + '</label>');
                            $('input[type="password"]', $form).val('');
                            loader.destroy( $loaderContainer );
                        }
                    }
                }
            });
        }



        //
        // PUBLIC
        //

        /**
         * init
         */
        function init(){
            $('body').on('submit', '.cc-form', function(event) {
                var $form = $(this),
                    valid = validateForm( $form );

                $('.form-msg', $form).remove();

                if(ajaxEnabled){
                    event.preventDefault();
                    if(valid){
                        processForm($form);

                        if( typeof ga === "function" ){
                            ga('send', 'event', 'button', 'login', 'User Add Product to Shopping Cart');
                        }
                    }
                }

            });

            $('body').on('submit', '.cc-logout-submit', function(event) {

                if(ajaxEnabled){
                    event.preventDefault();
                    var $form            = $(this),
                        action           = $form.attr('action'),
                        $loaderContainer = $('#cc-modal .modal-content'),
                        ajaxData         = {
                            action : 'cc_ajax_logout_user',
                            proxy  : action
                        };

                    loader.init( $loaderContainer );

                    $.ajax({
                        url: cc_ajax.ajaxurl,
                        data: ajaxData,
                        error: ajaxError,
                        success: function(data, textStatus, jqxhr) {
                            location.reload();
                        }
                    });
                }
            });
        }

        return {
            init: init
        };
    })(); // form




    /* --------------------------------------------
     * --modules
     * -------------------------------------------- */


    var sectionBanner = (function(){

        /**
         * init
         */
        function init(name){

            //
            // toggle the opening and closing of the block overlay
            //
            $('.js-toggle-block-modal').on('click', function(event){
                event.preventDefault();
                var $module = $(this).closest('.cc-module');

                $module.toggleClass('block-overlay--active');

                if($module.hasClass('block-overlay--active')){
                    var moduleTop = $module.offset().top - 80;

                    $('body, html').animate({
                        scrollTop : moduleTop + 'px'
                    });

                }
            });
        }

        return {
            init : init
        };
    })(); // sectionBanner



    var contentRiver = (function(){

        var defaultHeight = 0,
            slideoutMarkup;


        /**
         * ajaxInlineContent
         *
         * go and grab the post content with ajax
         * @param postId // the post ID of the content we're looking to get
         */
        function ajaxInlineContent(postId){

            var ajaxData = {
                action : 'cc_ajax_post',
                postId : postId
            };

            return $.ajax({
                url: cc_ajax.ajaxurl,
                data: ajaxData,
                error: ajaxError,
                success: function(data, textStatus, jqxhr) {
                    if(data !== 'error'){
                        slideoutMarkup = data;
                    }
                },
            });
        }



        /**
         * addSlideoutMarkup
         *
         * insert the slideout markup into the DOM
         */
        function addSlideoutMarkup($t){

            var slidespeed = 400,
                tOffset    = $t.offset().top - 60,
                $slideout  = $('#cc-slideout'),
                $inSlider  = $slideout.closest('.flex-viewport'),
                sHeight;

            if($inSlider.length > 0){
                setTimeout(function(){
                    sHeight = $slideout.css({
                        'visibility' : 'hidden',
                        'position'   : 'absolute',
                        'display'    : 'block'
                    }).height();

                    $slideout.removeAttr('style').slideDown(slidespeed, function(){
                        $('body').removeClass('river-animating');
                        $(this).addClass('active');
                    });

                    alignSlideoutAndSlider( $inSlider, sHeight );

                    $('.js-close-slideout, .flex-direction-nav a').off('click').on('click', closeSliderClick);

                    $('body, html').animate({
                        scrollTop: tOffset + 'px'
                    });

                    loader.destroy($t);

                }, 1000);
            } else {

                $slideout.slideDown(slidespeed, function(){
                    $('body').removeClass('river-animating');
                    $(this).addClass('active');
                });

                $('.js-close-slideout').off('click').on('click', closeSliderClick);

                $('body, html').animate({
                    scrollTop: tOffset + 'px'
                });

                loader.destroy($t);
            }


            /**
             * closeSliderClick
             */
            function closeSliderClick(event){
                event.preventDefault();

                $('body').removeClass('slideout--active');

                $slideout.removeClass('active').closest('.content-river').find('.river-post.active').removeClass('active');
                setTimeout(function(){
                    if($inSlider.length > 0){
                        resetSliderHeight($inSlider);
                    }
                    $slideout.slideUp(slidespeed, function(){
                        $slideout.remove();
                    });
                }, 400);

            }
        }



        /**
         * alignSlideoutAndSlider
         *
         * if the slideout takes place within a slideshow, align the heights
         * @param $slider // the slider we're updating the height of
         * @param height  // the additional height to tack onto the slider
         */
        function alignSlideoutAndSlider( $slider, height ){

            var $activeSlide = $('.flex-active-slide', $slider),
                activeHeight = $activeSlide.height(),
                newHeight    = activeHeight + height;

            defaultHeight = activeHeight;

            $activeSlide.css({
                height : newHeight + 'px'
            });
        }

        /**
         * resetSliderHeight
         *
         * reset the slider height
         * @param $slider // the slider we're updating the height of
         */
        function resetSliderHeight( $slider ){

            var $activeSlide = $('.cc-slide', $slider);

            $activeSlide.addClass('cc-util--transition-height').height(defaultHeight);
        }


        /**
         * getRiverCols
         *
         * util function to get the number of columns in the river
         * @param ww // window width
         */
        function getRiverCols(ww){
            if( ww < 421 ){
                return 1;
            } else if( ww < 769 ){
                return 2;
            } else {
                return 4;
            }
        }

        /**
         * getRiverBlockCells
         *
         * util function to get the number of columns in the river
         * @param ww // window width
         */
        function getRiverBlockCells(ww){
            var ww = $(window).width();

            if( ww < 421 ){
                return 2;
            } else if( ww < 768 ){
                return 4;
            } else {
                return 8;
            }
        }



        /**
         * setupFrontpageBulletin
         *
         * due to all the fun stuff with widths and things, setup the
         *  bulletin slider depending on the width of the browser
         */
        function setupFrontpageBulletin(){

            var $slider = $('#frontpage-bulletin-slider');

            var cells    = getRiverBlockCells(),
                $posts   = $('.river-post', $slider).remove(),
                numPosts = $posts.length,
                markup   = '<div class="cc-slide cc-util--transition-height cc-cf" style="height:560px;">';

            $slider.addClass('cc-slider');

            $posts.each(function(i, post){
                var realIndex = i + 1;
                markup += post.outerHTML;
                if( ( i !== 0 ) && ( realIndex % cells === 0 ) && ( realIndex !== numPosts ) ){
                    markup += '</div><div class="cc-slide cc-util--transition-height cc-cf" style="height:560px;">';
                }
            });

            markup += '</div>';

            $('.slides-container', $slider).append(markup);

            sliders.createFlexslider($slider);

            setTimeout(function(){
                $('.cc-slide:not(.clone) .river--video-background').bigvideo();
            }, 100);
        }

        /**
         * loadMorePosts
         * when cta with id "loadmore" is clicked, this function will unhide 3 posts/divs at a time
         *
         * inputs:
         *   parentEl: a string representing the selector of the parent of the elements hidden/shown
         *   childEl: a string representing the selector of the children elements being hidden/shown
         */
        function loadMorePosts(parentEl, childEl){
          $('#loadmore').click(function() {
            hidden = $(parentEl  + ' ' + childEl + ':hidden' );
            console.log(hidden.size());

            if ( hidden.length < 4 ) {
              hidden.slideDown();
              $('#loadmore').hide();
            } else {
              hidden.slice(1, 4).slideDown();
            }
          })
        }

        /**
         * loadAll
         * when cta with a given id is clicked, this function will unhide all the rest of the posts
         *
         * inputs:
         *   selector: the name of the
         *   parentEl: a string representing the selector of the parent of the elements hidden/shown
         *   childEl: a string representing the selector of the children elements being hidden/shown
         */
        function loadAll(parentEl, childEl){
          $('#loadall').click(function() {
            hidden = $(parentEl  + ' ' + childEl + ':hidden' );
            hidden.slideDown();
            $('#loadall').hide();
            $('#viewless').show();
          });
        }

        function viewLess(parentEl, childEl) {
          $('#viewless').click(function() {
             $('#viewless').hide();
             $(parentEl).children().slice(3).slideUp();
             $('#loadall').show();
           })
        }




        //
        // public
        //

        /**
         * init
         */
        function init(){

            setupFrontpageBulletin();
            loadMorePosts('.storygrid', '.storygrid__cell');
            loadAll('#asset-archive', '.asset');
            viewLess('#asset-archive', '.asset');
            //
            // content block - display content inline
            //
            $('.js-inline-content').on('click', function(event){
                event.preventDefault();

                var $body = $('body'),
                    $self = $(this);

                if(ajaxEnabled && ! $body.hasClass('river-animating') && ! $self.hasClass('active')){

                    var ww        = $(window).width(),
                        $posts    = $self.siblings('.river-post').add($self),
                        thisIndex = $self.index(),
                        cols      = getRiverCols(ww),
                        colEnd    = thisIndex - 1 + (cols - ( thisIndex % cols) );
                        $endEl    = $posts.eq(colEnd).length > 0 ? $posts.eq(colEnd) : $posts.last();
                        postId    = $self.data('post');

                    $self.addClass('active');
                    $body.addClass('river-animating');

                    if( $body.hasClass('slideout--active') ){
                        $('.js-close-slideout').trigger('click');
                    }

                    $body.addClass('slideout--active');

                    loader.init($self);

                    ajaxInlineContent(postId).done( function(){
                        setTimeout(function(){
                            var arrowOffset = $self.offset().left + ($self.width() / 2);
                            if($('#cc-slideout').length === 0){
                                $endEl.after('<div id="cc-slideout" class="slideout-container"><div class="slideout-arrow" style="left:' + arrowOffset + 'px;"></div><div class="cc-container">' + slideoutMarkup + '</div></div>');
                            }
                            addSlideoutMarkup($self);

                        }, 500);
                    });
                }
            });
        }

        return {
            init : init
        };

    })(); // contentRiver






    var flipper = (function(){

        var $flipperContainer = $('.cc-content-flipper');


        /**
         * moveIndicator
         *
         * move the indicator for flipper nav
         * @param slide    // (string) the id of the slide to move to
         * @param $flipper // (jquery obj) the flipper we're working with
         */
        function moveIndicator(slide, $flipper){

            $('.flipper-navigation li.active', $flipper).removeClass('active');

            var $indicator = $('.flipper-navigation li[data-slide="' + slide + '"]').addClass('active');

            if($(window).width() > 1136){
                $indicator = $indicator.children('a');
            }

            if($indicator.length > 0){
                var indicatorLeft  = $indicator.position().left,
                    indicatorWidth = $indicator.outerWidth();

                $('.flipper-nav--indicator', $flipper).css({
                    'left'  : indicatorLeft + 'px',
                    'width' : indicatorWidth + 'px'
                });
            } else {
                $('.flipper-nav--indicator', $flipper).css({
                    'left'  : $('.flipper-navigation', $flipper).width(),
                    'width' : '0px'
                });
            }
        }


        /**
         * updateFlipperGraphic
         *
         * update the graphic elements for this flipper
         * @param slide    // (string) the id of the slide to move to
         * @param $flipper // (jquery obj) the flipper we're working with
         */
        function updateFlipperGraphic(slide, $flipper){
            if($('.graphic-nav', $flipper).length > 0){
                $('.graphic-nav.active', $flipper).removeClassSVG('active');
                $('.graphic-nav[data-slide="' + slide + '"]', $flipper).addClassSVG('active');
            }
        }



        //
        // PUBLIC
        //

        /**
         * init
         */
        function init(){

            $flipperContainer.each(function(){
                var $flipper   = $(this),
                    $container = $('.flipper-content--container', $flipper),
                    $content   = $('.flipper-content', $flipper),
                    elHeight   = tallestEl($content);

                $container.height(elHeight);

                $('.cc-slide--image.engage-slider', $flipper).flexslider({
                   selector       : '.flipper-slideshow > .flipper-image',
                   animation      : 'slide',
                   animationSpeed : 400,
                   slideshow      : false,
                   controlNav     : false,
                   directionNav   : false,
                   touch          : false
               });

                if( $(window).width() < 1137 ){
                    var $nav      = $('.flipper-navigation li', $flipper),
                        numSlides = $nav.length;

                    alignHeights($nav);

                    $nav.css('width', (100/numSlides) + '%');
                }

                if($('.flipper-navigation li.active', $flipper).length > 0){
                    moveIndicator($('.flipper-navigation li.active', $flipper).data('slide'), $flipper);
                }
            });


            //
            // navigation listener
            //
            $('.flex-direction-nav a', $flipperContainer).on('click', function(event) {
                event.preventDefault();

                var $flipper = $(this).closest('.cc-content-flipper'),
                    $active  = $('.flipper-content.active', $flipper),
                    slideId;

                if($(this).hasClass('flex-prev')){
                    slideId = $active.prev().length > 0 ? $active.prev().data('slide') : $('.flipper-content:last-child', $flipper).data('slide');
                } else {
                    slideId = $active.next().length > 0 ? $active.next().data('slide') : $('.flipper-content:first-child', $flipper).data('slide');
                }

                flipContent(slideId, $flipper);
                updateFlipperGraphic(slideId, $flipper);

            });

            //
            // control nav listener and mobile nav listener
            //
            $('.flipper-navigation a', $flipperContainer).on('click', function(event) {
                event.preventDefault();
                var $self    = $(this),
                    $flipper = $self.closest('.cc-content-flipper'),
                    slide    = $self.closest('li').data('slide');

                flipContent(slide, $flipper);
                updateFlipperGraphic(slide, $flipper);
            });

            //
            // graphic nav
            //
            $('.graphic-nav', $flipperContainer).on('click', function(event) {
                event.preventDefault();
                var $self    = $(this),
                    $flipper = $self.closest('.cc-content-flipper'),
                    slide    = $self.data('slide');

                flipContent(slide, $flipper);
                updateFlipperGraphic(slide, $flipper);
            });

        } // init



        /**
         * flipContent
         *
         * move the flipper
         * @param slide    // (string) the id of the slide to move to
         * @param $flipper // (jquery obj) the flipper we're working with
         */
        function flipContent(slide, $flipper){

            var $activeContent = $('.flipper-content[data-slide="' + slide + '"]', $flipper),
                slider         = $('.cc-slide--image.engage-slider', $flipper).data('flexslider'),
                $prevActive    = $activeContent.addClass('active').siblings('.active').removeClass('active').addClass('outgoing');

            if(slider){
                var newSlide = $activeContent.length ? $activeContent.index() :  0;
                slider.flexAnimate(newSlide);
            }

            setTimeout(function(){
                $prevActive.removeClass('outgoing');
            }, 400);
            moveIndicator(slide, $flipper);
        }



        return {
            init        : init,
            flipContent : flipContent
        };
    })(); // flipper



    var checkerboards = (function(){

        var $checkerboards = $('.cc-checkerboard-flipper');

        /**
         * init
         */
        function init(){
            $checkerboards.each(function(){
                var self       = this,
                    $container = $('.checkerboard-content--container', self),
                    $content   = $('.flipper-content', self),
                    $flipper   = $content.parent(),
                    height     = tallestEl($content);

                $container.height(height);

                if( $(window).width() < 769 ){
                    var svg_more = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="277.9 368.6 54 54" enable-background="new 277.9 368.6 54 54" xml:space="preserve"><g><circle fill="none" stroke="#ACBABC" stroke-miterlimit="10" cx="304.9" cy="395.6" r="25"/><polyline fill="none" stroke="#3D4349" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" points="300.7,408.3 313.4,395.6 300.7,382.9"/></g></svg>';
                    $('.cc-checkerboard', self).wrap('<div class="cc-slider"></div>');
                    $('.cc-checkerboard--content .centering-wrapper--table', self).append('<h6><a class="checkerboard--next-slide" href="#">Next Step <span class="ico ico--next-step">' + svg_more + '</span></a></h6>');

                    sliders.createFlexslider($('.cc-slider', self), {
                        selector: '.cc-checkerboard > .cell',
                        before  : function(slider){
                            var currSlide = slider.animatingTo;
                            flipper.flipContent( currSlide, $flipper );
                        }
                    });

                    $('.cc-checkerboard-flipper').on('click', '.checkerboard--next-slide', function(event) {
                        event.preventDefault();
                        var slider    = $('.cc-slider', self).data('flexslider'),
                            nextSlide = slider.currentSlide + 1 < slider.count ? slider.currentSlide + 1 : 0;
                        slider.flexAnimate(nextSlide);
                    });
                }
            });


            //
            // checkerboard nav
            //
            $('.cc-checkerboard .cell').on('click', function(event) {
                event.preventDefault();

                var $cell    = $(this).addClass('active'),
                    $flipper = $cell.closest('.cc-module').find('.cc-checkerboard--content'),
                    step     = $cell.data('step');

                $cell.siblings('.active').removeClass('active');

                flipper.flipContent( step, $flipper );
            });
        }


        return {
            init: init
        };
    })(); // checkerboards



    var growers = (function(){

        var $growersSlider = $('.cc-growers-slider');

        /**
         * init
         */
        function init(name){

            $growersSlider.each(function(){
                var $slider = $(this),
                    $parent = $slider.closest('.growers-block--drawer');

                sliders.createFlexslider( $slider, {
                    directionNav: false
                });

                // close the growers drawer
                $('.slider-close', $parent).on('click', function(event) {
                    event.preventDefault();
                    $parent.removeClass('active');   
                });

                $('.slider-nav-action', $parent).on('click', function(event) {
                    event.preventDefault();
                    var slider    = $slider.data('flexslider'),
                        dir       = $(this).data('dir');
                        nextSlide = slider.currentSlide + dir;

                    if(nextSlide + 1 > slider.count){
                        nextSlide = 0
                    } else if( nextSlide < 0){
                        nextSlide = slider.count - 1;
                    }

                    slider.flexAnimate(nextSlide);
                });
            });

            //
            // open the slider
            //
            $('.cc-growers-block .js-trigger-grower-graphic').on('click', function(event) {
                event.preventDefault();
                var $self            = $(this),
                    grower           = $self.data('grower'),
                    $sliderContainer = $self.closest('.cc-growers-block').find('.growers-block--drawer').addClass('active'),
                    $slides          = $('.cc-slide:not(.clone)', $sliderContainer),
                    slider           = $('.cc-growers-slider', $sliderContainer).data('flexslider'),
                    indexCounter     = 0;

                $slides.each(function(i, el){
                    if($(el).data('grower') === grower){
                        indexCounter = i;
                        return false;
                    }
                });

                $sliderContainer.addClass('force-slide-switch');
                slider.flexAnimate(indexCounter);

                setTimeout(function(){
                    $sliderContainer.removeClass('force-slide-switch');
                }, 400);

            });
        }


        return {
            init: init
        };
    })(); // growers



    var fullpageImageContent = (function(){

        var $galleryImageCaptions = $('.fullpage-image--caption');

        /**
         * init
         */
        function init(){

            $galleryImageCaptions.each(function(){
                var $self        = $(this),
                    onPhone      = $(window).width() < 769,
                    scrollHeight = onPhone ? $self.closest('.cc-module').height() : $self.height();

                $('.scrollable', $self).outerHeight( scrollHeight );

                if(onPhone){
                    var selfY = $self.position().top + 40;
                    $self.css('top', selfY + 'px');
                }

                $('.fullpage-image--readmore', $self).on('click', function(event) {
                    event.preventDefault();
                    var $container = $(this).closest('.fullpage-image--caption'),
                        containerH = $container.height();

                    $container.animate({
                        scrollTop: containerH + 'px'
                    });

                    if( onPhone ){
                        $container.css('top', '0px');
                    }
                });
            });

            // since the "back" button isn't in the fullpage-image--caption div,
            //  we need to keep this outside that scope
            $('.js-fullpage-image--trigger-gallery').on('click', function(event) {
                event.preventDefault();
                $(this).closest('.banner-slideshow').toggleClass('retracted');
            });
        }


        return {
            init: init
        }
    })(); // fullpageImageContent
    
    // function handleStats() {
    //     var counter = document.getElementById('treesNumber');
    //     var bounds = counter.getBoundingClientRect();
        
    //     if (bounds.top > 0 && bounds.bottom < window.innerHeight) {
    //         if (!counter.classList.contains("is-active")) {
    //             var number = parseInt(counter.dataset.counter);
    //             var countup = new CountUp(counter, number);
                
    //             if (!countup.error) {
    //                 countup.start();
    //                 counter.classList.add("is-active");
    //             } else {
    //                 console.error(countUp.error);
    //             }
    //         }
    //     } else {
    //         console.error(countUp.error);
    //         counter.classList.remove("is-active");
    //     }
        
    // }
    function handleStats() {
      document.querySelectorAll(".js-counter").forEach(function(stat, i) {
        const bounds = stat.getBoundingClientRect();
        if (bounds.top > 0 && bounds.bottom < window.innerHeight) {
          if (!stat.classList.contains("is-active")) {
            const number = parseInt(stat.dataset.counter);
            const options = {
                  duration: 4,
              };
              const countup = new CountUp(stat, 0, number, 0, 2, options);
            if (!countup.error) {
              countup.start();
              stat.classList.add("is-active");
            }
          }
        } else {
          //stat.classList.remove("is-active");
        }
      });
    }

    function counterInit() {
        if (document.querySelectorAll(".js-counter").length > 0) {
          $(window).on("scroll", handleStats).trigger("scroll");
        }
    }

    
    function grabElouanModal() {
        var doubleModal = $(".plant-a-tree.grappos-lp #grappos-locator"); 
        
        if (doubleModal) {
        setTimeout(function() {
            var doubalModalHtml = doubleModal.html();
            var footerModal = $("#cc-modal--grappos-modal #grappos-locator");

            footerModal.html(doubalModalHtml);
        }, 5000);
        }
    }
    
    function shoppingCart() {
        $( ".shopping-cart-button:not(.belle-glos)" ).on('click', function( event ) {
            event.preventDefault();
            var form = $(this).closest('form');

            
            var sku = form.find("input[name=PART]").val();
            var qty = form.find("input[name=QTYORD]").val();
            
            
            $(form).attr("action", "https://quiltandco.com/collection/wine?addToCart=" + sku + "&quantity=" + qty);
            $(form).submit();
        });
    }

    /* --------------------------------------------
     * --public functions
     * -------------------------------------------- */
    COPPERCANE.init = function(){

        //
        // init all the sliders
        //
        sliders.initAll();


        //
        // ux
        //
        ux.init();


        //
        // parallax
        //
        parallax.init();


        //
        // modals
        //
        modals.init();


        //
        // grappos
        //
        grappos.init();


        //
        // forms
        //
        form.init();



        // -------------------------------
        // modules
        //

        // section banner interactions
        sectionBanner.init();

        // fullpage image with caption
        fullpageImageContent.init();


        // content river
        contentRiver.init();

        // flipper
        flipper.init();

        // checkerboards
        checkerboards.init();

        // growers
        growers.init();


        singleElouanInstagram();

        counterInit();

        grabElouanModal();

        shoppingCart();
    }


    // -------------------------------
    // DOM ready
    //
    $(document).ready(function(){
        COPPERCANE.init();
    });
})(window.COPPERCANE = window.COPPERCANE || {}, jQuery);
